import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UrlService {

  private previousUrl: BehaviorSubject<string> = new BehaviorSubject<string>('');
  readonly previousUrl$: Observable<string> = this.previousUrl.asObservable();

  setPreviousUrl(previousUrl: string , currentURL : string) {
    this.previousUrl.next(previousUrl);
    localStorage.setItem('previouseurl', previousUrl);
    localStorage.setItem('Currenturl', currentURL)
  }
}
